import { useMutation } from "react-query";
import deleteSkuPoOcr from "../services/deleteSkuPoOcr";

const useDeleteSkuPoOcr = () => {
  return useMutation(["delete-sku-po-ocr"], deleteSkuPoOcr);
};

export default useDeleteSkuPoOcr;
